import { Box, Checkbox, Grid, Typography } from '@mui/material'
import React from 'react'
import TextBox from '../../../common/TextBox';
import { isCheckFareLimit, useDebouncedHandler } from '../../../utils/helpers';
import { fareUpdateLimitObj, updateSelectedSeat } from '../constant';
import { useDispatch } from 'react-redux';
import { showErrorAlert } from '../../../redux/Actions';

const TripSeatFare = (props) => {
    const dispatch = useDispatch()
    const { tripTotalAmt = {}, bkgDeatails = {}, setBkgDetails, setFilterOpt, filterOpt, selectedSeat = [], setSelectedSeat = () => { } } = props

    let disableFare = !(bkgDeatails?.roleRight?.AllowFareChange2 === 1)
    const fareList = [
        { field: "seaterLow", label: "SIT-NAC", disabled: true, size: 1.6, type: "number" },
        { field: "seaterHigh", label: "SIT-AC", disabled: true, size: 1.6, type: "number" },
        { field: "sleeperLow", label: "SLP-NAC", disabled: true, size: 1.6, type: "number" },
        { field: "sleeperHigh", label: "SLP-AC", disabled: true, size: 1.6, type: "number" },
        { field: "slumberLow", label: "SLM-NAC", disabled: true, size: 1.6, type: "number" },
        { field: "slumberHigh", label: "SLM-AC", disabled: true, size: 1.9, type: "number" },
        { field: "tax", label: "GST", disabled: true, size: 2.1, type: "number" },
        { field: "discount", label: "Trip Discount", disabled: true, size: 1.6, type: "number" },
        { field: "servicecharge", label: "Service Charge", disabled: false, size: 1.6, type: "number" },
        { field: "pickUpAndDropOffChrg", label: "P. D. Charge", disabled: true, size: 1.6, type: "number" },
        { field: "seaterAmt", field1: 'seaterCount', label: "Seater", disabled: true, size: 1.6, type: "text" },
        { field: "sleeperAmt", field1: 'sleeperCount', label: "Sleeper", disabled: true, size: 1.6, type: "text" },
        { field: "seatFareIsDiscount", label: "Agt Discount", disabled: disableFare, size: 1.9, type: "text" },

        {
            field: "grandAmt",
            label: "Grand Total",
            size: 2.1,
            type: "number",
        }
    ];
    const handleInputField = (field, value = 0) => {
        setBkgDetails((prev) => ({
            ...prev,
            [field]: value
        }))
        if (field !== 'servicecharge') {
            let newChartData = updateSelectedSeat(field, value, filterOpt?.chartData || [])
            let newSelSeatData = updateSelectedSeat(field, value, selectedSeat || [])
            setFilterOpt((prev) => ({
                ...prev,
                chartData: newChartData
            }))
            setSelectedSeat(newSelSeatData)
        }
    }
    const debouncedInputField = useDebouncedHandler((field, value) => {
        handleInputField(field, value)
    }, 500);
    const handleDiscountFare = (event) => {
        setBkgDetails((prev) => ({
            ...prev,
            [event.target.name]: event.target.checked
        }))
        let newSeatData = selectedSeat.map((obj) => {
            if (event.target.checked) {
                return { ...obj, baseFare: obj.disBaseFare }
            }
            return { ...obj, baseFare: obj.orgBaseFare }
        })
        setSelectedSeat([...newSeatData])
    }

    return (
        <Box className='tripSeatFare_page'>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                flexWrap={'wrap'}
                alignItems="stretch"
                sx={{ padding: '0px' }}
                columnSpacing={{ xs: '8px' }}
                rowSpacing={{ xs: '12px' }}
            >
                {fareList.map((obj) => (
                    <>
                        {obj.field === 'seatFareIsDiscount' ?
                            <Grid item size={obj.size}>
                                <Box className={`discountFare ${obj.disabled ? '' : 'active'}`}>
                                    <Typography>{obj.label}</Typography>
                                    <Checkbox checked={bkgDeatails?.seatFareIsDiscount}
                                        disabled={obj.disabled}
                                        name='seatFareIsDiscount' onChange={(event) => {
                                            handleDiscountFare(event)
                                        }} />
                                </Box>
                            </Grid>
                            :
                            obj.field === 'grandAmt' ?
                                <Grid item size={obj.size}>
                                    <Box sx={{ flex: 1 }} className='grandtotal'>
                                        <Typography>Grand Total: {tripTotalAmt?.[obj.field] || 0}
                                        </Typography>
                                    </Box>
                                </Grid>
                                :
                                <Grid item size={obj.size} className={`smallTextBox28 ${(obj.field === 'seaterAmt' || obj.field === 'sleeperAmt') ? 'seatCounterBox' : ''}`}>
                                    <TextBox
                                        label={obj.label}
                                        type={obj.type}
                                        value={({ ...bkgDeatails, ...tripTotalAmt })?.[obj.field] || 0}
                                        disabled={obj.disabled}
                                        name={obj.field}
                                        onChange={(event) => {
                                            if (!(obj.disabled)) {
                                                const { name, value } = event.target;
                                                debouncedInputField(name, value)
                                            }
                                        }}
                                        onBlur={(event) => {
                                            if (['seaterLow', 'seaterHigh', 'sleeperLow', 'sleeperHigh', 'slumberLow', 'slumberHigh'].includes(obj.field)) {
                                                const { name, value } = event.target;
                                                let checkLimit = isCheckFareLimit(bkgDeatails, name, value)
                                                if (checkLimit) {
                                                    let limitOnFareChange = bkgDeatails?.limitOnFareChange || 0
                                                    let limitOnFareChangePer = bkgDeatails?.limitOnFareChangePer || 0
                                                    let tripDetails = bkgDeatails?.tripDetails
                                                    dispatch(showErrorAlert(`Fare cannot be changed more than ${limitOnFareChangePer > 0 ? `${limitOnFareChangePer} %` : `${Number(limitOnFareChange || 0)} Rs`}`))
                                                    debouncedInputField(name, Number(tripDetails?.[fareUpdateLimitObj?.[name]]))
                                                }
                                            }
                                        }}

                                    />
                                    {(obj.field === 'seaterAmt' || obj.field === 'sleeperAmt') &&
                                        <Box className='seatCounter'>
                                            {tripTotalAmt?.[obj.field1] || 0}
                                        </Box>
                                    }
                                </Grid>
                        }
                    </>

                ))}
            </Grid>

        </Box>
    )
}

export default TripSeatFare